import { render } from "./Reservation.vue?vue&type=template&id=fbd28850"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__